import React from "react";
import { Box, Tooltip, SxProps, Theme } from "@mui/material";

type LetterBadgeProps = {
  /** Letra (o texto muy corto) que se muestra dentro del círculo. */
  letter: string;
  /** Texto completo que se muestra al pasar el ratón. */
  title: string;
  sx?: SxProps<Theme>;
};

// Círculo compacto con una letra, pensado para columnas estrechas de tablas
// (categoría, estado...). El significado completo va en el tooltip.
const LetterBadge: React.FC<LetterBadgeProps> = ({ letter, title, sx }) => (
  <Tooltip title={title}>
    <Box
      component="span"
      aria-label={title}
      sx={{
        width: 26,
        height: 26,
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.75rem",
        fontWeight: 700,
        lineHeight: 1,
        flexShrink: 0,
        cursor: "default",
        ...sx,
      }}
    >
      {letter}
    </Box>
  </Tooltip>
);

export default LetterBadge;
